"use client";

import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
interface ServiceArea {
  name: string;
}
const SERVICE_AREAS: ServiceArea[] = [{
  name: "El Mamsha"
}, {
  name: "Sheraton Road"
}, {
  name: "Dahar"
}, {
  name: "Hurghada Marina"
}, {
  name: "Senzo Mall"
}, {
  name: "Hurghada City"
}, {
  name: "Resort-zu-Resort-Transfers"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: [0.21, 0.47, 0.32, 0.98]
    }
  }
};
export default function ServiceAreas() {
  return <section id="taxiserviceareas" data-nav="light" className="relative bg-background text-foreground py-16 md:py-20">
      <div className="max-w-[1136px] mx-auto px-6">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-40px"
      }} variants={containerVariants} className="flex flex-col items-center text-center">
          <motion.div variants={itemVariants} className="w-full max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-accent-foreground">
              Taxi-Einsatzgebiete in Hurghada
            </h2>

            {/* Signature hairline divider anchored by golden sun accent dot */}
            <div className="flex items-center justify-center gap-3 my-6">
              <div className="h-px w-16 bg-border" />
              <div className="size-2 rounded-full bg-primary" />
              <div className="h-px w-16 bg-border" />
            </div>
          </motion.div>

          <motion.div variants={containerVariants} className="w-full mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 justify-center">
            {SERVICE_AREAS.map((area, i) => <motion.div key={area.name} data-index={i} variants={itemVariants} className="group relative flex items-center gap-3.5 px-5 py-4 rounded-lg bg-card/70 border border-border transition-all duration-180 hover:bg-card hover:border-primary/60 hover:shadow-xs">
                <div className="flex items-center justify-center size-8 rounded-full bg-primary/15 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-180 shrink-0">
                  <MapPin className="size-4" />
                </div>
                <span className="text-base font-medium text-accent-foreground group-hover:text-foreground text-left transition-colors duration-180">
                  {area.name}
                </span>
              </motion.div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}